import React from "react";
import { Col, Row, Breadcrumb, Typography } from "antd";
import { Link } from "react-router-dom";
import { translate } from "../../../locale";
import CompaniesTable from "../../../components/Tables/CompaniesTable";

const { Title } = Typography;

const Companies = () => {
  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row>
        <Col className="gutter-row" span="12">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{translate("Empresas")}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Empresas")}
          </Title>
        </Col>

        <Col span="24" className="mt-6">
          <CompaniesTable />
        </Col>
      </Row>
    </div>
  );
};

export default Companies;
